import api from 'api';
import bus from 'bus';
import membersip from 'repositories/purchase/subscription';
import serverFeatures from 'modules/features/server';
import {id as clientId} from 'modules/me';
import config from 'config';

let freeMembership = config.features['free-membership'];

/*
 * TODO: make periodical checking while user is active on page or make WebSocket communication.
 */
function check() {

    var balancePromise = new Promise(function(resolve){
        api.credits.accounts.balance.get(clientId, function (err, data) {
            resolve(data);
        });
    });
    var membershipPromise = new Promise(function(resolve){
        membersip.check(function (data) {
            resolve(data);
        });
    });

    Promise.all([balancePromise, membershipPromise]).then(function(values){
        var balanceData = values[0];
        var membershipData = values[1];
        var eventModel = {
            'purchase': !(membershipData.state == 'none' || membershipData.state == 'inactive'),
            'free-membership': freeMembership && membershipData.state == 'none',
            tiles: !!serverFeatures('in-my-account-experiment') || serverFeatures('arabiandate')
        };

        if(balanceData){
            eventModel.balance = balanceData.balance;
        }
        bus.emit('event.model.change', eventModel);
    });
}

export function create() {

    bus.sync('authorized', function () {
        check();
        bus.on('event.purchase.success', check);

    });
}